import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { GET_WIDGET } from "../../../constants/endpoints";
import Loader from "../../../shared/loader/loader";
import axios from "axios";
import { InstallWidgetsModal } from "./customize-donation-widgets/components/install-widget-modal";
import LinkQRCode from "../../../shared/qr-code/qr-code";
import { downloadSVGAsImage } from "../../../utils/utils";
import { EmbedWidgetsModal } from "./customize-donation-widgets/components/embed-widget-modal";

function SharingDonation(props) {
  const params = useParams();
  const target_id = params.campaign_id;
  const navigate = useNavigate();
  const type = params.type;
  const [dataLoader, setDataLoader] = useState(false);
  const [campaignWidgetData, setCampaignWidgetData] = useState(null);
  const [widgetType, setWidgetType] = useState('');
  const [copySuccess, setCopySuccess] = useState('');
  const [showInstallationModal, setShowInstallationModal] = useState(false);
  const [showEmbedModal, setShowEmbedModal] = useState(false);


  useEffect(() => {
    setDataLoader(true);
      axios.get((GET_WIDGET + `${target_id}/${type}`))
        .then((res) => {
          if (res?.data?.status) {
            setCampaignWidgetData(res?.data?.response);
          }
           setDataLoader(false);
        }).catch((error) => {
          setDataLoader(false);
        });
  }, [])
  const copyLink = async (flag) => {
    if(flag){
      await navigator.clipboard.writeText(`${window.location.origin}${type === 'special-product' ? '/special-fundraising/' : '/iftar-sponsorship/'}${campaignWidgetData?.organization?.organization_short_name ? campaignWidgetData?.organization?.organization_short_name : 'masjid'}/${campaignWidgetData?.donation_page_link}`);
      setCopySuccess('Link Copied!');
    }
    else{
      await navigator.clipboard.writeText(`${window.location.origin}/${campaignWidgetData?.organization?.organization_short_name ? campaignWidgetData?.organization?.organization_short_name : 'masjid'}/${type === 'membership' ? 'campaign' : type === 'special-product' ? 'product' : type}/${campaignWidgetData?.donation_page_link}`);
      setCopySuccess('Copied!');
    }
    setTimeout(() => setCopySuccess(''), 2000);
  }
  return (
    <>
        <div className="row">
          <div className="col-xl-12">
            <div className="row mb-4">
              <div className="d-flex flex-md-row flex-column justify-content-between align-items-center">
                <div>
                  <p className="font-weight-semibold text-black f-24 mb-1">
                    Sharing: <span className="text-black f-24 text-bold">{campaignWidgetData?.campaign_title}</span>
                  </p>
                  <span className="text-muted">
                    Share your campaign link, embed donation forms or buttons on your website, and customize widgets to reach supporters anywhere.
                  </span>
                </div>
                <div className="mt-2">
                  <Link to={null} onClick={() => setShowInstallationModal(true)} className="text-black cursor-pointer pt-2 pb-2 pe-3 px-3">
                    <span><i className="fa-regular fa-file"></i></span>
                    <span className="ms-2 text-black text-bold">Installation Guide</span>
                  </Link>
                  <button onClick={()=> navigate(`/${type}s`)} className="me-3 mt-md-0 btn btn-outline-secondary text-primary mb-0">Cancel</button>
                </div>
              </div>
            </div>
            <div className="row position-relative">
              {!dataLoader ? <>


                {/* CARD: Campaign Link */}
                <div className="col-xl-6 mb-3 d-flex">
                  <div className="card flex-fill shadow-sm p-4 d-flex flex-column justify-content-between">
                    <div>
                      <h6 className="text-primary font-weight-bold mb-2">Your Campaign Link</h6>
                      <p className="text-muted mb-3" style={{ fontSize: 14 }}>Easily share this link with your supporters via email, social media, or text.</p>
                      <a
                        className="d-block text-primary text-decoration-underline mb-3"
                        href={`${campaignWidgetData?.organization?.organization_short_name ? campaignWidgetData?.organization?.organization_short_name : 'masjid'}/${type === 'membership' ? 'campaign' : type === 'special-product' ? 'product' : type}/${campaignWidgetData?.donation_page_link}`}
                        target="_self">
                        {`${window.location.origin}/${campaignWidgetData?.organization?.organization_short_name ? campaignWidgetData?.organization?.organization_short_name : 'masjid'}/${type === 'membership' ? 'campaign' : type === 'special-product' ? 'product' : type}/${campaignWidgetData?.donation_page_link}`}
                      </a>
                    </div>
                    <div className="text-center">
                      <button className={`btn btn-outline-primary w-100`} onClick={()=>copyLink(false)}>
                        <i className="fa-solid fa-copy me-2"></i>
                        {copySuccess === 'Copied!' ? copySuccess : 'Copy Link'}
                      </button>
                    </div>
                  </div>
                </div>

                {/* CARD: Scan-to-donate */}
                <div className="col-xl-6 mb-3 d-flex">
                  <div className="card flex-fill shadow-sm p-4 d-flex flex-column justify-content-between">
                    <div>
                      <h6 className="text-primary font-weight-bold mb-2">Scan-to-donate</h6>
                      <p className="text-muted mb-3" style={{ fontSize: 14 }}>Print and scan this QR code for donors to give directly to your campaign.</p>
                      <div className="text-center mb-3">
                        <LinkQRCode
                          url={`${window.location.origin}/${campaignWidgetData?.organization?.organization_short_name ? campaignWidgetData?.organization?.organization_short_name : 'masjid'}/${type === 'membership' ? 'campaign' : type === 'special-product' ? 'product' : type}/${campaignWidgetData?.donation_page_link}`}
                          name={campaignWidgetData?.campaign_title}
                          qrCode={target_id}
                          id={campaignWidgetData?.id}
                          showDownload={false} />
                      </div>
                    </div>
                    <div className="d-flex justify-content-center gap-2">
                      <button className="btn btn-outline-primary flex-fill" onClick={() => downloadSVGAsImage('QRSvg', campaignWidgetData?.campaign_title, 'png')}><i className="fa-solid fa-download me-2"></i>PNG</button>
                      <button className="btn btn-outline-primary flex-fill" onClick={() => downloadSVGAsImage('QRSvg', campaignWidgetData?.campaign_title, 'jpg')}><i className="fa-solid fa-download me-2"></i>JPG</button>
                      <button className="btn btn-outline-primary flex-fill" onClick={() => downloadSVGAsImage('QRSvg', campaignWidgetData?.campaign_title, 'pdf')}><i className="fa-solid fa-download me-2"></i>PDF</button>
                    </div>
                  </div>
                </div>

                
                {/* CARD: TV Display Link */}
                {type === 'special-product' || type === 'special-program'?
                <div className="col-xl-6 mb-3 d-flex">
                  <div className="card flex-fill shadow-sm p-4 d-flex flex-column justify-content-between">
                    <div>
                      <h6 className="text-primary font-weight-bold mb-2">TV Display Link</h6>
                      <p className="text-muted mb-3" style={{ fontSize: 14 }}>Real-time grid display with QR code. Use this link to display it on your Masjid TV screens.</p>
                      <a
                        className="d-block text-primary text-decoration-underline mb-3"
                        href={`${type === 'special-product' ? '/special-fundraising/' : '/iftar-sponsorship/'}${campaignWidgetData?.organization?.organization_short_name ? campaignWidgetData?.organization?.organization_short_name : 'masjid'}/${campaignWidgetData?.donation_page_link}`}
                        target="_self">
                        {`${window.location.origin}${type === 'special-product' ? '/special-fundraising/' : '/iftar-sponsorship/'}${campaignWidgetData?.organization?.organization_short_name ? campaignWidgetData?.organization?.organization_short_name : 'masjid'}/${campaignWidgetData?.donation_page_link}`}
                      </a>
                    </div>
                    <div className="text-center">
                      <button className={`btn btn-outline-primary w-100`} onClick={()=>copyLink(true)}>
                        <i className="fa-solid fa-copy me-2"></i>
                        {copySuccess === 'Link Copied!' ? copySuccess : 'Copy Link'}
                      </button>
                    </div>
                  </div>
                </div> : ''}

                {/* CARD: Website Widget */}
                {type === 'special-product' ?
                <div className="col-xl-6 mb-3 d-flex">
                  <div className="card flex-fill shadow-sm p-4 d-flex flex-column justify-content-between">
                      <div className="text-center mt-4 mb-4">
                        <img src="./img/masjid/waffle.png" alt="Waffle Chart" style={{ maxHeight: 120, maxWidth: 200, transform: 'scale(1.4)' }} />
                      </div>
                      <div className="mb-3 mt-4">
                      <h6 className="text-primary font-weight-bold">Website Widget</h6>
                      <p className="text-muted" style={{ fontSize: 14 }}>
                        Real-time grid display with donate button for your Masjid website.
                      </p>
                      </div>
                    <div className="d-flex justify-content-center gap-2">
                      <button className="btn btn-outline-primary flex-fill" 
                       onClick={() => { setShowEmbedModal(true); setWidgetType('waffle') }}><i className="fa-solid fa-code me-2"></i>Embed Code</button>
                    </div>
                  </div>
                </div> : ''}

                {/* CARD: Donate Button */}
                {type !== 'program' && type !== 'special-program' ?
                <div className="col-xl-6 mb-3 d-flex">
                  <div className="card flex-fill shadow-sm p-4 d-flex flex-column justify-content-between">
                      <div className="text-center mt-4 mb-4">
                        <img src="./img/masjid/donate-button.png" alt="Donate Button" style={{ maxHeight: 120, maxWidth: 200 }} />
                      </div>
                      <div className="mb-3 mt-4">
                      <h6 className="text-primary font-weight-bold">Donate Button</h6>
                      <p className="text-muted" style={{ fontSize: 14 }}>
                        Embed a button anywhere on your website that pops open your campaign's donation form.
                      </p>
                      </div>
                    <div className="d-flex justify-content-center gap-2">
                      {campaignWidgetData?.widget ? 
                      <button className="btn btn-outline-primary flex-fill" 
                      disabled={campaignWidgetData?.widget ? false : true} onClick={() => { setShowEmbedModal(true); setWidgetType('button') }}><i className="fa-solid fa-code me-2"></i>Embed Code</button> : ''}
                      <a className="btn btn-outline-primary flex-fill" onClick={() => { navigate(`/customize-donation-widget/${target_id}/${type}/button`) }}>
                        <span>
                          <i className="fa-solid fa-gear me-2"></i>
                        </span>
                        <span>Customize</span>
                      </a>
                    </div>
                  </div>
                </div>: ''}

                {/* CARD: Donation Form
        <div className="col-xl-6 mb-3 d-flex">
          <div className="card flex-fill shadow-sm p-4 d-flex flex-column justify-content-between">
            <div>
              <div className="text-center mb-3">
                <img src="./img/masjid/donate-form.png" alt="Donate Form" style={{maxHeight: 120, maxWidth: 200 }} />
              </div>
              <h6 className="text-primary font-weight-bold mb-2">Donation Form</h6>
              <p className="text-muted mb-3" style={{ fontSize: 14 }}>
                Embed your donation form directly onto your website.
              </p>
            </div>
            <div className="d-flex justify-content-center gap-2">
              <button className="btn btn-outline-primary flex-fill"><i className="fa-solid fa-code me-2"></i>Embed Code</button>
              <button className="btn btn-outline-primary flex-fill"><i className="fa-solid fa-gear me-2"></i>Customize</button>
            </div>
          </div>
        </div> */}

                {/* CARD: Fundraising Tracker */}
                 {type !== 'program' ?
                <div className="col-xl-6 mb-3 d-flex">
                  <div className="card flex-fill shadow-sm p-4 d-flex flex-column justify-content-between">
                      <div className="text-center mt-4 mb-4">
                        <img src="./img/masjid/donate-bar.png" alt="Fundraising Tracker" style={{ maxHeight: 120, maxWidth: 200, transform: 'scale(1.8)', marginTop: '6px' }} />
                      </div>
                      <div className="mb-3 mt-4">
                      <h6 className="text-primary font-weight-bold">Fundraising Tracker</h6>
                      <p className="text-muted" style={{ fontSize: 14 }}>
                        Showcase your campaign’s success with a real-time fundraising progress.
                      </p>
                      </div>
                    <div className="d-flex justify-content-center gap-2">
                      {campaignWidgetData?.widget ?
                      <button className="btn btn-outline-primary flex-fill" disabled={campaignWidgetData?.widget ? false : true} onClick={() => { setShowEmbedModal(true); setWidgetType('goal') }}><i className="fa-solid fa-code me-2"></i>Embed Code</button> : ''}
                      <a className="btn btn-outline-primary flex-fill" onClick={() => { navigate(`/customize-donation-widget/${target_id}/${type}/goal`) }}>
                        <span>
                          <i className="fa-solid fa-gear me-2"></i>
                        </span>
                        <span>Customize</span>
                      </a>
                    </div>
                  </div>
                </div>: ''}
              </>
                : <Loader />
              }

              <InstallWidgetsModal
                show={showInstallationModal}
                onHide={() => setShowInstallationModal(false)}
              />
              <EmbedWidgetsModal
                show={showEmbedModal}
                onHide={() => setShowEmbedModal(false)}
                target={widgetType === 'waffle' ? target_id : campaignWidgetData?.widget?.masjid_id}
                type={widgetType}
                widget_id={campaignWidgetData?.widget?.widget_id ?? 'none' }
              />
            </div>
          </div>
        </div>
    </>
  );
}

export default SharingDonation;